var map = {
	"./logo-dark-bg.svg": 399,
	"./logo-inline-dark-bg.svg": 7889,
	"./logo-inline-white.svg": 4394,
	"./logo-inline.svg": 9870,
	"./logo-tagline-dark-bg.svg": 3126,
	"./logo-tagline-white.svg": 2933,
	"./logo-tagline.svg": 6273,
	"./logo-white.svg": 9124,
	"./logo.svg": 2820,
	"./token-white.svg": 1200,
	"./token.svg": 2752
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3739;